import { AddSickCertForm } from "components/AddSickCertForm/AddSickCertForm";
import { Dialog } from "components/ui/Dialog";

export const AddSickCertModal = ({ open, patientId, onClose, onSuccess }) => (
  <Dialog open={open} onClose={onClose} title="New Sick Certificate" width={680} minHeight={500}>
    <AddSickCertForm
      patientId={patientId}
      isReadOnly={false}
      /*
       * Closed only on the Save the clinician pressed. The form also saves in the
       * background — choosing a template saves first, so the server substitutes the
       * placeholders from the current values — and closing on that would take the
       * form away mid-edit.
       */
      onSuccess={({ isUserInitiated } = {}) => {
        onSuccess?.();

        if (isUserInitiated) onClose?.();
      }}
    />
  </Dialog>
);
